<div class="feedback-questionnaire-full-description">
    <h1 mat-dialog-title tabIndex="0">
        {{ data.title | translate}}
        <i class="dolineo-icon dolineo-icon-close dolineo-icon-gray"
           matTooltip="{{'Common.Close' | translate}}"
           matTooltipPosition="below"
           matTooltipClass='below-top'
           (click)="dialogRef.close()"></i>
    </h1>
    <div mat-dialog-content class="description-content">
        <div class="expand-all" (click)="expandAll()"
             *ngIf="!expand">{{ 'FeedbackUserReport.ExpandAll' |translate }}</div>
        <div class="expand-all" (click)="collapseAll()"
             *ngIf="expand">{{ 'FeedbackUserReport.CollapseAll' |translate }}</div>
        <ng-container *ngIf="dataReady">
            <ng-container *ngFor="let area of data.areas; let aidx = index;">
                <mat-expansion-panel hideToggle [expanded]="false" class="description-content__area" *ngIf="!area.textBlock">
                    <mat-expansion-panel-header #panelA>
                        <mat-panel-title>
                            <button mat-button
                                    matTooltip="{{(panelA._isExpanded()? 'Common.Collapse': 'Common.Expand') | translate}}"
                                    matTooltipPosition="below"
                                    matTooltipClass='below-top'
                                    type="button">
                                <img [src]="panelA._isExpanded() ?
                                                            'assets/icons/arrow-full-down.svg' :
                                                            'assets/icons/arrow-full-right.svg'"
                                     [ngStyle]="{'top': panelA._isExpanded() ? '1px' : '0px'}"
                                     alt="arrow-full-right">
                            </button>
                            <div class="description-content__area--content">
                                <span class="description-content__area--content--label">{{ ('QuestionnaireCreator.Area' |translate) + ' ' + (aidx + 1) + ':'}} </span>
                                <span class="description-content__area--content--title">{{ area.name }}</span>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="behaviour-details white-box"
                         *ngFor="let competence of area.competences; let cidx = index;">

                        <mat-expansion-panel hideToggle [expanded]="false"
                                             class="description-content__area__competence">
                            <mat-expansion-panel-header #panelC>
                                <mat-panel-title>
                                    <button mat-button
                                            matTooltip="{{(panelC._isExpanded()? 'Common.Collapse': 'Common.Expand') | translate}}"
                                            matTooltipPosition="below"
                                            matTooltipClass='below-top'
                                            type="button">
                                        <img [src]="panelC._isExpanded() ?
                                                            'assets/icons/arrow-full-down.svg' :
                                                            'assets/icons/arrow-full-right.svg'"
                                             [ngStyle]="{'top': panelC._isExpanded() ? '1px' : '0px'}"
                                             alt="arrow-full-right">
                                    </button>
                                    <div class="description-content__area__competence--content">
                                        <span class="description-content__area__competence--content--label">{{ ('QuestionnaireCreator.Competence' |translate) + ' ' + competence.counter + ':'}} </span>
                                        <span class="description-content__area__competence--content--title">{{ competence.description }}</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="description-content__area__competence__behaviour"
                                 *ngFor="let behaviour of competence.behaviours; let bidx = index;">
                                <div class="description-content__area__competence__behaviour--content">
                                    <span class="description-content__area__competence__behaviour--content--label">{{ ('QuestionnaireCreator.Behavior' |translate) + ' ' + behaviour.counter + ':'}} </span>
                                    <span class="description-content__area__competence__behaviour--content--title">{{ behaviour.description }}</span>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </mat-expansion-panel>
            </ng-container>
        </ng-container>
    </div>

    <div mat-dialog-actions class="dialog-footer">
        <button mat-button color="primary" (click)="dialogRef.close(true)"
                class="dolineo-button blue-button">{{(data.okText || 'Common.Close') | translate}}</button>
    </div>
</div>
